module.exports = __webpack_public_path__ + "img/logo.6c1f1bb6.png";